import React, { useState, useEffect, useRef, useMemo, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select';
import ReactDatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import enGB from 'date-fns/locale/en-GB';
import { useTranslation } from 'react-i18next';
import UserService from '../../Services/user.service';
import '../../pages/OtherDocuments/OtherDocument.css';
import backIcon from '../../assests/images/left-arrow.png';
import EnumsService from '../../Services/enums.service';
import CustomDeleteConfirmationModal from '../../Components/CustomDeleteConfirmationModal/CustomDeleteConfirmationModal.js'
import { ToastContainer, toast } from "react-toastify";
import DownloadIcon from '@mui/icons-material/Download';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useBack } from "use-back";
import NoDocumentsPdf from "../../assests/pdf/NoDocument.pdf";
import { useSignalR } from '../../Contexts/signalR';
import { Dropdown } from 'primereact/dropdown';
import 'primereact/resources/themes/saga-blue/theme.css';  // Optional: PrimeReact theme
import 'primereact/resources/primereact.min.css';           // PrimeReact CSS
import 'primeicons/primeicons.css';
import SaveIcon from '@mui/icons-material/Save'; // Save icon
import ClearIcon from '@mui/icons-material/Clear';
import AdvancedDropdown from '../../Components/AdvancedDropdown/AdvancedDropdown.js';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import MergeIcon from '@mui/icons-material/Merge';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import CustomMonthDatePicker from '../../Components/Widgets/CustomDates/CustomMonthDatePicker/CustomMonthDatePicker.js';
import editIcon from '../../assests/images/Icons/editIcon.svg';
import PuffLoader from "react-spinners/PuffLoader";
import generateDepreciationReportHtml from "../../Components/Assets/SubComponents/AssetDepreciationReportHTML.js";
import NavigationButton from '../../Components/NavigationButton/NavigationButton.jsx';




//table imports
import { Edit as EditIcon, Delete as DeleteIcon, Download as DownloadIconMui, Search as SearchIcon } from '@mui/icons-material';
import '../../pages/Document/Document.scss';
import {
    Button, Dialog, DialogTitle, DialogContent, Box, DialogActions, TextField, Checkbox,
    InputAdornment, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, MenuItem,
    ToggleButton, ToggleButtonGroup, Switch, CircularProgress, Tooltip, FormControlLabel,
    Grid
} from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import { beautifyNumber } from '../../Utils/FormatNumber';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import styled from '@mui/system/styled';
import UpperPanelDetails from '../../Components/Widgets/UpperPanelDetails/UpperPanelDetails.jsx';
import AutocompleteSelect from '../../Components/Widgets/AutocompleteSelect/AutocompleteSelect.jsx';
import CustomMonthYearIndividualDatePicker from '../../Components/Widgets/CustomDates/CustomMonthYearIndividualDatePicker/CustomMonthYearIndividualDatePicker.js';
import AssetService from '../../Services/assets.service';
import AssetTable from '../../Components/Assets/SubComponents/AssetTable.js';
import EditAsset from '../../Components/Assets/SubComponents/EditAsset.js';
import AddAsset from '../../Components/Assets/SubComponents/AddAsset.js';
import AddAssetGroup from '../../Components/Assets/SubComponents/AddAssetGroup.js';
import EditAssetGroup from '../../Components/Assets/SubComponents/EditAssetGroup.js';
import AssetImportModal from '../../Components/Assets/SubComponents/AssetImportModal.js';
import SoldAssetsViewer from '../../Components/Assets/SubComponents/SoldAssetsViewer.js';
import CapitalGainSoldAssetsModal from '../../Components/Assets/SubComponents/CapitalGainCalculationModal/CapitalGainSoldAssetsModal.jsx';
import CapitalGainCalculationModal from '../../Components/Assets/SubComponents/CapitalGainCalculationModal';
import SnapshotViewer from '../../Components/Assets/SubComponents/SnapshotViewer.js';
import DocumentService from '../../Services/documents.service';
import EditModal from '../../Components/EditModal/EditModal.js';
import AssetDepreciationReportHTML from '../../Components/Assets/SubComponents/AssetDepreciationReportHTML.js';
import SubAccountantService from '../../Services/subAccountant.service';
import ChooseAsset from '../../Components/Widgets/ChooseAsset/ChooseAsset.js';
import DepreciationJournalEntriesModal from '../../Components/Widgets/DepreciationJournalEntriesModal/DepreciationJournalEntriesModal.jsx';
import Constants from '../../assests/Constants/constants';
import { validateDocumentBeforeProcessing } from '../../Utils/documentValidation.js';
import { stripRelatesToFromDescription, appendRelatesToDescription } from '../../Utils/assetDescriptionUtils';
import ClientService from '../../Services/client.service';
import ClientDocumentCountService from '../../Services/ClientDocumentCount.service';
import { width } from '@mui/system';
import { NavHistoryContext } from '../../Contexts/NavHistoryContext';
import SmallTransactionViewer from '../../Components/Assets/SubComponents/SmallTransactionViewer.js';
import CustomYearDatePicker from '../../Components/Widgets/CustomDates/CustomYearDatePicker/CustomYearDatePicker.js';
import DenseTable from '../../Components/DenseTable/DenseTable.js';
import { useHamburgerMenu } from '../../Contexts/HamburgerMenuContext';

registerLocale('en-GB', {
    ...enGB,
    localize: {
        ...enGB.localize,
        month: n => n + 1, // Display months as numbers starting from 1
    },
    formatLong: {
        ...enGB.formatLong,
        date: () => 'MM/yyyy', // Date format when the picker is not showing
    },
});

setDefaultLocale('en-GB'); // Set the default locale to use it
const StyledDialogTitle = styled(DialogTitle)({
    fontSize: '1.8rem',
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#304FFF',
});

const StyledDialogContent = styled(DialogContent)({
    textAlign: 'center',
    padding: '20px 30px',
});

const StyledDialogActions = styled(DialogActions)({
    justifyContent: 'center',
    paddingBottom: '20px',
});

const StyledButton = styled(Button)({
    margin: '0 8px',
    padding: '10px 20px',
    fontSize: '1.1rem',
    textTransform: 'none',
    color: '#fff',
    backgroundColor: '#E57C22',
    '&:hover': {
        backgroundColor: '#d9731a',
    },
});
const PaymentTypeOptions = [
    { name: "CreditCard", value: "0" },
    { name: "Check", value: "1" },
    { name: "BankTransfer", value: "2" },
    { name: "Cash", value: "3" }
];



const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    width: '100%',
    height: '10vh',
    '& .MuiAutocomplete-root': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: "center"

    },
    '& *': {
        boxSizing: 'border-box !important',

    },
    '& .MuiDataGrid-columnHeaders': {
        // opacity: 0.7,
        backgroundColor: '#BFC8FF',
    },
    '& .MuiDataGrid-columnHeader': {
        backgroundColor: '#BFC8FF',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        color: '#304FFF',
        textAlign: 'center',
        fontFamily: 'Montserrat',
        fontSize: '14px',
        fontWeight: 600,
        lineHeight: 'normal',
    },
    '& .MuiDataGrid-cell': {
        borderTop: '1px solid rgba(191, 191, 193, 0.56)',
        backgroundColor: 'rgba(234, 237, 255, 0.32)',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
    },
    '& .MuiDataGrid-row:hover': {
        backgroundColor: 'rgba(191, 200, 255, 0.3)',
    },
    '& .MuiDataGrid-cell:focus': {
        outline: 'none',
    },
    '& .MuiDataGrid-cell': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: "center"
    },
    '& .disableUser': {
        pointerEvents: 'none',
        opacity: 0.5,
    },
    // New styles for edit mode
    '& .MuiDataGrid-cell--editing': {
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingLeft: '8px',
        paddingRight: '8px',
    },
    '& .MuiDataGrid-row--editing .MuiDataGrid-cell': {
        borderRight: 'none',
    },
    '& .MuiDataGrid-row--editing .MuiDataGrid-cell:not(:last-child)': {
        borderRight: '8px solid transparent',
    },
    '& .MuiDataGrid-cell--editing': {
        padding: 0,
        backgroundColor: 'inherit',
    },
}));

const OptionButton = styled(Button)({
    margin: '10px 8px',
    padding: '12px 25px',
    fontSize: '1.1rem',
    textTransform: 'none',
    color: '#304FFF',
    backgroundColor: '#f5f5f5',
    border: '1px solid #E57C22',
    width: 'auto',  // Allows the button to shrink when there are many buttons
    maxWidth: '200px',  // Set a maximum width to ensure consistency
    flexGrow: 1,  // Allows buttons to fill available space equally
    '&:hover': {
        backgroundColor: '#E57C22',
        color: '#fff',
    },
});



const ActionButton = styled(Button)({
    backgroundColor: '#E57C22', // Consistent background with other elements
    borderRadius: 4, // Same border-radius as MUI TextField and Switch
    color: 'white',
    height: 40, // Same height as other input elements
    padding: '0 16px', // Consistent padding
    fontSize: '0.875rem', // Matching font size with TextField
    textTransform: 'none',
    boxSizing: 'border-box',
    '&:hover': {
        backgroundColor: '#d9731a', // Slightly darker on hover
    },
    '&:disabled': {
        backgroundColor: '#E0E0E0',
        color: '#BDBDBD',
    },
});


function Assets() {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const direction = i18n.dir();
    const [user, setUser] = useState(null);
    const [token, setToken] = useState('');
    const [client, setClient] = useState(null);
    const [type, setType] = useState('');
    const location = useLocation();
    const { goBack } = useContext(NavHistoryContext);

    const [loading, setLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ key: 'cardId', direction: 'descending', type: 'number' });
    const [isEditSingleEntryOpen, setIsEditSingleEntryOpen] = useState(false);
    const [editModalCurrentIndex, setEditModalCurrentIndex] = useState(-1);
    const [vatEquipmentTransactions, setVatEquipmentTransactions] = useState([]);
    const [isTransactionViewerOpen, setIsTransactionViewerOpen] = useState(false);
    const [equipmentAssetSummaryHeader, setEquipmentAssetSummaryHeader] = useState([]);
    const [equipmentAssetSummaryRows, setEquipmentAssetSummaryRows] = useState([]);




    const [assets, setAssets] = useState([]);
    const [assetGroups, setAssetGroups] = useState([]);
    const [assetRelations, setAssetRelations] = useState([]);
    const [expandedRows, setExpandedRows] = useState({});
    const [selectedAsset, setSelectedAsset] = useState(null);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [addModalOpen, setAddModalOpen] = useState(false);
    const [addGroupModalOpen, setAddGroupModalOpen] = useState(false);
    const [editGroupModalOpen, setEditGroupModalOpen] = useState(false);
    const [selectedAssetGroup, setSelectedAssetGroup] = useState(null);
    const [reportHtmlContent, setReportHtmlContent] = useState("");
    const [depreciationData, setDepreciationData] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [isJournalEntrySelectionModalOpen, setIsJournalEntrySelectionModalOpen] = useState(false);
    const [showAssetImportModal, setShowAssetImportModal] = useState(false);
    const [showSoldAssetsViewer, setShowSoldAssetsViewer] = useState(false);
    const [showCapitalGainSoldModal, setShowCapitalGainSoldModal] = useState(false);
    const [selectedCapitalGainAsset, setSelectedCapitalGainAsset] = useState(null);
    const [showSnapshotViewer, setShowSnapshotViewer] = useState(false);


    const [date, setDate] = useState(null);
    const [isReportModalOpen, setIsReportModalOpen] = useState(false);
    // In your Assets component:
    const handleCloseReport = () => {
        setIsReportModalOpen(false);
    };



    //-------------------Edit Item---------------------------
    const [editedDocument, setEditedDocument] = useState({});
    const [editedAddAccountCard, setEditedAddAccountCard] = useState(false);
    const [accountCardOptions, setAccountCardOptions] = useState([]);
    const [creditAccountOptions, setCreditAccountOptions] = useState([]);
    const [debitAccountOptions, setDebitAccountOptions] = useState([]);
    const [clientItems, setClientItems] = useState([]);
    const [oldAccountName, setOldAccountName] = useState({});
    const [oldAccountCaseId, setOldAccountCaseId] = useState({});
    const [oldAccountCardId, setOldAccountCardId] = useState({});

    const [accountCardEditDownloadOptions, setAccountCardEditDownloadOptions] = useState([]);
    const [sortCodeIdOptions, setSortCodeIdOptions] = useState([]);
    const [statusCheck, setStatusCheck] = useState(false);
    const [isClosedReportingMonth, setIsClosedReportingMonth] = useState(false);
    const [subAccountantOptions, setSubAccountantOptions] = useState([]);
    const [fade, setFade] = useState(false);
    const [isFirstUserFetched, setIsFirstUserFetched] = useState(false);

    const [reportDate, setReportDate] = useState(() => {
        const stored = localStorage.getItem('EndDate');
        return stored ? new Date(stored) : new Date();
    });

    const { setMenuProps, refreshEnumsCallback } = useHamburgerMenu();
    useEffect(() => {
        setMenuProps({ client });
    }, [client, setMenuProps]);

    //-------------------------------------------------------


    const handleEditGroupClick = (group) => {
        setSelectedAssetGroup(group);
        setEditGroupModalOpen(true);
    };

    const closeEditGroupModal = () => {
        setEditGroupModalOpen(false);
        setSelectedAssetGroup(null);
    };

    const handleAddGroupClick = () => setAddGroupModalOpen(true);
    const closeAddGroupModal = () => setAddGroupModalOpen(false);

    //account cards


    const fileInputRef1 = useRef(null); // Reference to the first hidden file input




    const [collectionPageData, setCollectionPageData] = useState({});
    const [startDate, setStartDate] = useState(() => {
        const storedDateString = localStorage.getItem('StartDate');
        return storedDateString ? new Date(storedDateString) : new Date();
    });;

    const [endDate, setEndDate] = useState(() => {
        const storedEndDateString = localStorage.getItem('EndDate');
        return storedEndDateString ? new Date(storedEndDateString) : new Date();
    });
    const assetsRef = useRef([]);
    const assetGroupsRef = useRef([]);
    const [showEmptyGroups, setShowEmptyGroups] = useState(false);
    const [fetchByYear, setFetchByYear] = useState(true);

    const fetchVatEquipmentTransactions = async (date) => {
        try {
            const vatEquipResponse = await AssetService.GetJournalEntriesAndExpensesWithVatEquipment(
                client?.caseId,
                client?.accountantId,
                date,
                token
            );

            if (vatEquipResponse.success) {
                setVatEquipmentTransactions(vatEquipResponse.data);
            }
        } catch (error) {
            console.error('Error fetching VAT Equipment Transactions:', error);
        }
    };


    const inputPropsStyle = {
        disableUnderline: true,
        className: `custom-input-box-sizing-toggle ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,

        sx: {
            height: '48px',
            width: '250px',
            padding: '0 10px',
            borderRadius: '8px',
            background: '#F5F5F6',
            border: '1px solid transparent',
            '&:focus-within': {
                border: '2px solid var(--Foundation-Blue-Normal, #304FFF)',
            },
        },
    };

    const fetchEnums = async (user, token, client, dateOverride = null, fetchByYearOverride = null) => {
        try {
            const dateForFetch = dateOverride || startDate;
            const useFetchByYear = fetchByYearOverride !== null ? fetchByYearOverride : fetchByYear;
            const vatEquipDate = useFetchByYear ? dateForFetch.toISOString() : null;
            const assetsYear = useFetchByYear ? dateForFetch.getUTCFullYear() : null;

            const assetResponse = await AssetService.GetAllAssets(client?.caseId, token, assetsYear);
            const assetGroupResponse = await AssetService.GetAllAssetGroups(client?.caseId, token);
            const equipmentSummary = await AssetService.GetPurchaseOfEquipmentBalance(client.caseId, client.accountantId, token, vatEquipDate);
            const vatEquipResponse = await AssetService.GetJournalEntriesAndExpensesWithVatEquipment(
                client?.caseId,
                client?.accountantId,
                vatEquipDate,
                token
            );
            try {
                const relationsResponse = await AssetService.GetAssetRelationsByCaseId(client?.caseId, token);
                if (relationsResponse?.success) {
                    setAssetRelations(relationsResponse.data || []);
                }
            } catch (relErr) {
                console.error('Error fetching asset relations:', relErr);
            }

            if (equipmentSummary?.success) {
                const data = equipmentSummary.data;

                setEquipmentAssetSummaryHeader([
                    t("TotalEquipmentBalance"),
                    t("TotalAssetAmount"),
                    t("Difference")

                ]);

                setEquipmentAssetSummaryRows([
                    {
                        TotalEquipmentBalance: beautifyNumber(data.equipmentBalance),
                        TotalAssetAmount: beautifyNumber(data.totalAssetAmount),
                        Difference: beautifyNumber(data.equipmentBalance - data.totalAssetAmount)

                    }
                ]);
            }

            if (assetResponse.success && assetGroupResponse.success) {
                assetsRef.current = assetResponse.data;
                assetGroupsRef.current = assetGroupResponse.data;
                setAssets(assetResponse.data);
                setAssetGroups(assetGroupResponse.data);


                if (vatEquipResponse?.success) {
                    setVatEquipmentTransactions(vatEquipResponse.data);
                }
            } else {
                toast.error(t('FailedToFetchAssets'));
            }
        } catch (error) {
            console.error(error);
            toast.error(t('fetchEnumsError'), error);
            // Handle the error appropriately
            // setIsClientDataFetched(false)
        }
        await fetchEnumsForEditModal(user, token, client);
        setLoading(false);

    };

    //depreciation report logic
    const handleViewReport = async (date = null, endMonth = null) => {

        if (!client) {
            toast.error("Client details missing");
            return;
        }
        setLoading(true);
        try {
            let response;
            if (endMonth) {
                response = await AssetService.GetDepreciationDetails(
                    client.caseId, null, token, endMonth
                );
            } else {
                const dateToUse = date !== null ? date : (reportDate || endDate);
                const selectedDate = dateToUse ? new Date(dateToUse) : new Date();
                const year = selectedDate.getUTCFullYear();
                const endOfYear = new Date(Date.UTC(year, 11, 31));
                response = await AssetService.GetDepreciationDetails(
                    client.caseId, endOfYear, token
                );
                setReportDate(endOfYear);
            }

            setDate(new Date().toISOString());
            setLoading(false);

            if (response && response.assetGroups.length > 0) {
                if (endMonth) setReportDate(new Date(endMonth));
                setDepreciationData(response);
                setIsReportModalOpen(true);
            } else {
                toast.error(t("No depreciation data available"));
            }
        } catch (error) {
            setLoading(false);
            toast.error("Error fetching depreciation report");
        }
    };





    const [expanded, setExpanded] = useState(false);
    useEffect(() => {
        if (!expanded) {
            setExpandedRows(assetGroups.reduce((acc, group) => {
                acc[group.assetGroupId] = true;
                return acc;
            }, {}));
            setExpanded(true);
        }

    }, [assetGroups]);

    useEffect(() => {
        const fetchUserData = async () => {
            setLoading(true);
            try {
                const currentUser = await UserService.getCurrentUser();
                const currentToken = await UserService.getCurrentToken();
                if (currentUser && currentToken) {
                    setUser(currentUser);
                    setToken(currentToken);

                    // Get client data from location.state
                    if (location.state && location.state.client && location.state.type) {
                        setType(location.state.type);
                        setClient(location.state.client);
                    }
                    await fetchEnums(currentUser, currentToken, location.state.client);
                    if (client) {
                        await handleViewReport();

                    }
                    // Fetch financial data for the current date on initial load only
                }
                else {
                    navigate("/login");
                }


            } catch (error) {
                // Handle error - maybe navigate to login or show a message
            }
            setLoading(false);
        };
        fetchUserData();
    }, [location.state.client]);

    const [cardIdOption, setCardIdOption] = useState(-1);



    const formatDate = dateString => {
        const date = new Date(dateString);
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };



    const handleSortChange = (key, type, Direction = '') => {
        let direction = Direction || 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }

        setSortConfig({ key, direction, type });
    };

    // table functions
    const headerStyle = {
        backgroundColor: '#f7f7f7',
        color: 'black',
        fontWeight: 'bold'
    }


    // useEffect(() => {
    //     // Calculate the width as 70% of the container width minus 20px
    //     const containerWidth = document.querySelector('.table-container').offsetWidth;
    //     const newWidth = (containerWidth * 0.7) - 20;
    //     setCalculatedWidth(newWidth + 'px');
    // }, []);

    const handleGoBack = () => {
        // Navigate back to the previous page using React Router
        if (client) {
            // handleBack();
            goBack()
        }
    };

    const [itemIdToDelete, setItemIdToDelete] = useState(null);
    const [deleteModalVisable, setDeleteModalVisable] = useState(null);

    const handleConfirmDelete = async () => {
        try {
            const response = await EnumsService.DeleteAccountCardsbyCaseId(client.caseId, itemIdToDelete.cardId, token);

            if (response.ok) {
                toast.success(t("Account card deleted successfully"));
                setDeleteModalVisable(false);
                fetchEnums(user, token, client); // Fetch updated enums after the delete action
            } else {
                const errorMessage = await response.text(); // Extract the error message from the response body
                if (errorMessage.includes("Account card can't be deleted, documents with account card exist")) {
                    toast.error(t('AccountCardCannotBeDeleted'));
                } else {
                    toast.error(t('TaskFailed'));
                }
            }

        } catch (error) {

            // Handle errors from the catch block (e.g., network issues or exceptions)
            if (error?.response?.data?.includes("Account card can't be deleted, documents with account card exist")) {
                toast.error(t('AccountCardCannotBeDeleted'));
            } else {
                toast.error(t('TaskFailed'));
            }
            console.error(t('TaskFailed'));
        }
    };
    const handleDeleteClick = (accountCard) => {
        setItemIdToDelete(accountCard);
        setDeleteModalVisable(true);
    };

    const clickedDisabled = (action) => {
        if (action === 'Edit') {
            toast.info(t('CannotEditThisAccountCard'));
        } else {
            toast.info(t('CannotDeleteAccountCard'));

        }
    };

    const clickedDisabledRow = () => {
        toast.info(t('LockedCardEditor'));
    };


    const formatDate3 = (value) => {

        if (!value) {
            return "-"
        }
        return dayjs(value).format('DD/MM/YYYY');
    };




    const [dialogOpen, setDialogOpen] = useState(false);





    const handleStartDateChange = async (date) => {
        const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));
        setStartDate(newDate);
        fetchVatEquipmentTransactions(fetchByYear ? date : null);
    };

    const handleYearChangeForDataFetch = async (date) => {
        if (!date) return;
        const year = new Date(date).getUTCFullYear();
        const newStartDate = new Date(Date.UTC(year, 0, 1));
        const newEndDate = new Date(Date.UTC(year, 11, 31));
        setStartDate(newStartDate);
        setEndDate(newEndDate);
        setReportDate(newEndDate);
        localStorage.setItem('StartDate', newStartDate.toISOString());
        localStorage.setItem('EndDate', newEndDate.toISOString());
        if (client && token && user) {
            await fetchEnums(user, token, client, newStartDate);
        }
    };

    const handleEndMonthChange = async (date) => {
        if (!date) return;
        const year = date.getFullYear();
        const newStart = new Date(Date.UTC(year, 0, 1));
        const newEnd = new Date(Date.UTC(year, date.getMonth() + 1, 0));
        setStartDate(newStart);
        setEndDate(newEnd);
        setReportDate(newEnd);
        localStorage.setItem('StartDate', newStart.toISOString());
        localStorage.setItem('EndDate', newEnd.toISOString());
        fetchVatEquipmentTransactions(newEnd);
        if (client && token && user) {
            setLoading(true);
            await fetchEnums(user, token, client, newStart, false);
        }
    };

    const handleStartDateChangeNew = async (newValue, type) => {


        const newDate = new Date(newValue);
        let updatedDate;



        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), startDate.getMonth(), 10));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(startDate.getFullYear(), newDate.getMonth(), 10));
        }





        localStorage.setItem('StartDate', updatedDate)
        setStartDate(updatedDate);
        fetchVatEquipmentTransactions(fetchByYear ? updatedDate : null);
    };

    const handleEndDateChangeNew = async (newValue, viewReport = true) => {
        if (!newValue) return;                   // guard against null/undefined

        // 1. Convert Dayjs → native Date (NO `new` keyword here)
        const newDate = newValue.toDate();

        // 2. Build the date range you need
        const year = newDate.getUTCFullYear();   // safe now
        const updatedDate = new Date(Date.UTC(year, 11, 10)); // Dec 10 (month index 11)
        const startDate = new Date(Date.UTC(year, 0, 1));   // Jan 1   (month index 0)

        // 3. Do the rest of your workflow
        if (viewReport) {
            await handleViewReport(updatedDate);
        }
        localStorage.setItem('EndDate', updatedDate.toISOString());
        setEndDate(updatedDate);
        fetchVatEquipmentTransactions(fetchByYear ? updatedDate : null);
    };



    const handleExpandClick = (groupId) => {
        setExpandedRows(prev => ({
            ...prev,
            [groupId]: !prev[groupId]
        }));
    };

    const handleRowClick = (id, type) => {
        if (type == 'asset') {
            const assetToSet = assetsRef.current.find(a => a.id === id);
            setSelectedAsset(assetToSet);
            setEditModalOpen(true);
        } else {
            const group = assetGroupsRef.current.find(a => a.assetGroupId === id);
            setSelectedAssetGroup(assetGroups.find(a => a.assetGroupId === id))
            setEditGroupModalOpen(true);
        }
    };



    const closeEditModal = () => {
        setAssignedDocument(null);
        setEditModalOpen(false);
        setSelectedAsset(null);
    };

    const [assignedDocument, setAssignedDocument] = useState(null);

    const handleAddClick = () => {


        setAssignedDocument(null);
        setSelectedAsset(null); // Clear selected asset for adding new
        setAddModalOpen(true);
    };

    const closeAddModal = () => {
        setAddModalOpen(false);
        setEditGroupModalOpen(false);
        setEditModalOpen(false);
        setAssignedDocument(false);
    };

    const handleAddAsset = async (newAsset) => {
        try {


            const formattedAsset = {
                caseId: client?.caseId,
                assetNumber: newAsset.assetNumber?.toString(),
                name: newAsset.name,
                description: newAsset.description || null,
                purchaseDate: new Date(newAsset.purchaseDate).toISOString(),
                activationDate: new Date(newAsset.activationDate).toISOString(),
                originalPrice: parseFloat(newAsset.originalPrice),
                depreciationPercentage: parseFloat(newAsset.depreciationPercentage),
                assetGroupId: newAsset.assetGroupId
            };


            if (assignedDocument) {
                if (assignedDocument.type === Constants.EntryType.Expense) {
                    formattedAsset.expenseId = assignedDocument.id;
                } else {
                    formattedAsset.journalEntryId = assignedDocument.id;
                }
            }

            const response = await AssetService.CreateAsset(formattedAsset, token);
            if (response.success) {
                const createdAsset = response.data;
                const newSerial = String(newAsset.assetNumber ?? '');
                const existingWithSerial = (assets || []).filter(
                    (a) => String(a.assetNumber) === newSerial
                );
                if (existingWithSerial.length > 0 && createdAsset) {
                    const allWithSerial = [...existingWithSerial, { ...createdAsset, purchaseDate: createdAsset.purchaseDate || newAsset.purchaseDate }]
                        .sort((a, b) => new Date(a.purchaseDate || 0) - new Date(b.purchaseDate || 0));
                    const primary = allWithSerial[0];
                    for (let i = 0; i < allWithSerial.length; i++) {
                        const item = allWithSerial[i];
                        const isPrimary = i === 0;
                        const newDesc = isPrimary
                            ? stripRelatesToFromDescription(item.description || '')
                            : appendRelatesToDescription(stripRelatesToFromDescription(item.description || ''), primary.name);
                        await AssetService.UpdateAsset({
                            Id: item.id,
                            CaseId: client?.caseId,
                            AssetNumber: item.assetNumber,
                            Name: item.name,
                            Description: newDesc,
                            PurchaseDate: item.purchaseDate,
                            ActivationDate: item.activationDate || item.purchaseDate,
                            SellDate: item.sellDate || null,
                            OriginalPrice: parseFloat(item.originalPrice),
                            DepreciationPercentage: parseFloat(item.depreciationPercentage),
                            AssetGroupId: item.assetGroupId || null,
                            ExpenseId: item.expenseId || null,
                            JournalEntryId: item.journalEntryId || null,
                        }, token);
                    }
                }

                if (newAsset.parentAssetId && createdAsset?.id) {
                    try {
                        // The picked asset becomes the ROOT, the newly created asset becomes its CHILD.
                        // Merge with any existing children of that root so we don't drop them.
                        const existingRelation = (assetRelations || []).find(
                            (r) => r?.rootAssetId === newAsset.parentAssetId
                        );
                        const existingChildIds = Array.isArray(existingRelation?.relatedAssetIds)
                            ? existingRelation.relatedAssetIds
                            : (existingRelation?.relatedAssets || []).map((ra) => ra.id);
                        const mergedIds = Array.from(new Set([...(existingChildIds || []), createdAsset.id]));

                        const relationResp = await AssetService.SaveAssetRelation(
                            {
                                caseId: client?.caseId,
                                rootAssetId: newAsset.parentAssetId,
                                relatedAssetIds: mergedIds,
                            },
                            token
                        );
                        if (!relationResp?.success) {
                            toast.error(relationResp?.error || t('Failed to save asset relation'));
                        } else {
                            try {
                                const relationsResponse = await AssetService.GetAssetRelationsByCaseId(client?.caseId, token);
                                if (relationsResponse?.success) {
                                    setAssetRelations(relationsResponse.data || []);
                                }
                            } catch (_) { /* non-fatal */ }
                        }
                    } catch (relErr) {
                        console.error('Error saving asset relation:', relErr);
                        toast.error(relErr?.message || t('Failed to save asset relation'));
                    }
                }

                toast.success(t('AssetAddedSuccessfully'));
                await fetchEnums(user, token, client);
                if (isReportModalOpen) {
                    await handleViewReport(reportDate);
                }

            } else {
                toast.error(t('Failed to add asset'));
            }
        } catch (error) {
            console.error(error);
            toast.error(t('An error occurred while adding asset'));
        }
    };

    const viewAttachDocument = () => {
        setIsTransactionViewerOpen(true);
    }

    const handleDelete = async (asset) => {

        if (!asset) {
            toast.error(t("Invalid asset details for deletion"));
            return;
        }

        try {
            const response = await AssetService.DeleteAsset(client.caseId, asset, token);
            if (response.success) {
                toast.success(t("AssetDeletedSuccessfully"));
                fetchEnums(user, token, client);
            } else {
                toast.error(t("Failed to delete asset"));
            }
            setEditModalOpen(false);
        } catch (error) {
            console.error(error);
            toast.error(t("An error occurred while deleting asset"));
        }
    };


    const viewAssetDocument = async (asset, type = 'buy') => {

        if (!asset) {
            console.error("No asset provided.");
            return;
        }

        let documentType = null;
        let documentId = null;

        if (type === 'buy') {
            if (asset.journalEntryId) { //journalEntryId
                documentType = "JournalEntries"; // Adjust based on actual API endpoint naming
                documentId = asset.journalEntryId;
            } else if (asset.expenseId) {
                documentType = "Expenses"; // Adjust based on actual API endpoint naming
                documentId = asset.expenseId;
            } else {
                toast.info(t('AssetDoesNotHaveAssociatedDocument'));
                return;
            }
        } else {
            if (asset.saleIncomeId) { //journalEntryId
                documentType = "Incomes"; // Adjust based on actual API endpoint naming
                documentId = asset.saleIncomeId;
            } else if (asset.saleJournalEntryId) {
                documentType = "JournalEntries"; // Adjust based on actual API endpoint naming
                documentId = asset.saleJournalEntryId;
            } else {
                toast.info(t('AssetDoesNotHaveAssociatedDocument'));
                return;
            }
        }


        try {

            const response = await DocumentService.GetDocumentById(documentType, client.caseId, documentId, token);

            if (!response.ok) {
                throw new Error(`Failed to fetch document: ${response.status}`);
            }

            let documentData = {};
            documentData = await response.json();
            documentData.documentType = documentType;
            documentData.docType = documentType;
            handleOpenEditSingleEntry(documentData);
        } catch (error) {
            console.error("Error fetching document:", error);
            console.error("errorFetchingData");
        }
    };

    const viewDocument = async (docId, type) => {

        let documentType = type;

        if (type === Constants.EntryType.Expense) {
            documentType = 'Expenses';
        } else if (type === Constants.EntryType.JournalEntry) {
            documentType = 'JournalEntries';
        } else {
            console.error('Unknown document type:', type);
            return; // Prevent further execution if the type is unknown
        }

        let documentId = docId;
        try {
            const response = await DocumentService.GetDocumentById(documentType, client.caseId, documentId, token);

            if (!response.ok) {
                throw new Error(`Failed to fetch document: ${response.status}`);
            }

            let documentData = {};
            documentData = await response.json();
            console.log(documentData);
            documentData.documentType = documentType;
            documentData.docType = documentType;
            handleOpenEditSingleEntry(documentData);
        } catch (error) {
            console.error("Error fetching document:", error);
            console.error("errorFetchingData");
        }
    };

    // filteredAndSortedData for EditModal navigation (from Equipment Transactions)
    const filteredAndSortedDataForEditModal = useMemo(() => {
        return vatEquipmentTransactions.map((tx) => ({
            ...tx,
            docType: tx.type === Constants.EntryType.Expense ? 'Expenses' : 'JournalEntries',
            id: tx.id,
        }));
    }, [vatEquipmentTransactions]);

    const handleEditModalPrevious = async () => {
        if (editModalCurrentIndex > 0) {
            const newIndex = editModalCurrentIndex - 1;
            const tx = vatEquipmentTransactions[newIndex];
            if (tx) {
                setEditModalCurrentIndex(newIndex);
                await viewDocument(tx.id, tx.type);
            }
        }
    };

    const handleEditModalNext = async () => {
        if (editModalCurrentIndex >= 0 && editModalCurrentIndex < vatEquipmentTransactions.length - 1) {
            const newIndex = editModalCurrentIndex + 1;
            const tx = vatEquipmentTransactions[newIndex];
            if (tx) {
                setEditModalCurrentIndex(newIndex);
                await viewDocument(tx.id, tx.type);
            }
        }
    };

    //------------------------This section is for edit modal-------------------------------


    const [formattedPalCodeOptions, setFormattedPalCodeOptions] = useState([]);
    const [accountant, setAccountant] = useState({});
    const [subAccountants, setSubAccountants] = useState([]);
    const fetchEnumsForEditModal = async (user, token, client) => {
        setLoading(true);
        try {
            // Initiate all fetch requests in parallel
            const [
                codeIdResponse,
                accountsResponse,
                clientItemsResponse,
                palCodesResponse
            ] = await Promise.all([
                EnumsService.GetSortCodesByAccountantId(client.accountantId, token),
                EnumsService.GetAccountCardsByCaseId(client.caseId, token),
                EnumsService.GetClientItemsByCaseId(client.caseId, token),
                EnumsService.GetPalCodesByAccountantId(client.accountantId, token)
            ]);

            // const response1 = await ClientService.CheckIfMonthClosed(client.caseId, newDate, token);
            // if (response1.ok) {
            //     const isClosedReportingMonth = await response1.json();
            //     setIsClosedReportingMonth(isClosedReportingMonth);
            // }

            // Process sortCodeIdOptions if response is okay
            if (codeIdResponse.ok) {
                const codeIdData = await codeIdResponse.json();
                setSortCodeIdOptions(codeIdData); // Assuming codeIdData is already in the correct format
            }

            // Process account options if response is okay
            if (accountsResponse.ok) {
                const accountsData = await accountsResponse.json();
                setCreditAccountOptions(accountsData);
                setDebitAccountOptions(accountsData); // Assuming both options are the same
                setAccountCardEditDownloadOptions(accountsData);
                const accountCardOptions = [{ name: t('AddAccountCard'), value1: 'AddItem' }, ...accountsData];
                setAccountCardOptions(accountCardOptions);

            }

            // Process client items if response is okay
            if (clientItemsResponse.ok) {
                const clientItemsData = await clientItemsResponse.json();
                clientItemsData.unshift({ makat: 'add-item', name: t('AddItem') });
                setClientItems(clientItemsData);
            }

            // Process palCodes if response is okay
            if (palCodesResponse.ok) {
                const palCodesData = await palCodesResponse.json();
                const formattedPalCodes = palCodesData.map(palCode => ({
                    label: palCode.palCodeId,
                    value: palCode.palCodeId
                }));
                setFormattedPalCodeOptions(formattedPalCodes);
            }

            //For File Processing----------------------------------------------------------------------------
            const result2 = await SubAccountantService.GetSubAccountantByAccountantId(token, user.accountantId);
            const accountantResult = await SubAccountantService.GetAccountantById(token, user.accountantId);
            const enhancedAccountantResult = {
                ...accountantResult,
                subAccountantId: accountantResult.accountantId, // Add subAccountantId as same as accountantId
            };
            setAccountant(enhancedAccountantResult);
            if (result2) {
                const combinedSubAccountants = [enhancedAccountantResult, ...result2];

                // If client exists, add it to the combined list
                if (client) {
                    combinedSubAccountants.push({
                        subAccountantId: client.caseId,
                        name: client.name,
                    });
                }

                setSubAccountants(combinedSubAccountants);

                const combinedOptions = combinedSubAccountants.map((acc) => ({
                    value: acc.subAccountantId,
                    label: acc.name,
                }));

                setSubAccountantOptions(combinedOptions);
            } else {
                toast.error(t('fetchSubAccountantsDataError'));
            }

            setIsFirstUserFetched(true);

        } catch (error) {
            toast.error(t('enumFetchError'));
        } finally {
            setLoading(false);
        }
    };

    const handleAccountCardSave = async (AccountCodeId, AccountCodeName, CompanyId) => {

        let response2;
        if (type === 'Incomes') {

            response2 = await EnumsService.AddAccountCard(client.caseId, AccountCodeId, AccountCodeName, CompanyId, "לקוחות", token);

        } else {

            response2 = await EnumsService.AddAccountCard(client.caseId, AccountCodeId, AccountCodeName, CompanyId, "ספקים", token);
        }
        if (!response2.ok) {

            throw new Error(`HTTP error! status: ${response2.status}`);
        }
    };


    const RefreshPage = async () => {
        handleCancel();
        await fetchEnums(user, token, client);
    }




    const handleReopenEdit = async (item, index) => {
        await fetchEnums(user, token, client);
    };
    const [actionType, setActionType] = useState('delete');
    const [editedPopupItem, setEditedPopupItem] = useState(true);
    const [forceProcessForCurrentEdit, setForceProcessForCurrentEdit] = useState(false);




    const handleEditDeleteClick = (itemId) => {
        setActionType('delete')
        setEditedPopupItem(false);
        setEditedDocument({});
        handleDeleteClick(itemId);
    };

    const handleCancel = () => {

        setEditedDocument({});
        setEditedAddAccountCard(false);
        setIsEditSingleEntryOpen(false);
    };

    const fetchDocumentsNotification = async (client, token) => {
        const documentCounts = await ClientDocumentCountService.getClientDocumentCountByCaseId(client.caseId, token);

        // Enrich clients with their total document counts
        const enrichedClient = {
            ...client,
            totalCounts: documentCounts.totalCounts || 0, // Default to 0 if no matching count is found
            documentCounts: documentCounts.documentCounts || {},
            documentIds: documentCounts.documentIds || {},
        };

        setClient(enrichedClient);
    }

    const handleDoneClick = async (itemId) => {
        setLoading(true);
        try {
            const response = await ClientDocumentCountService.removeDocumentByTypeAndId(client.caseId, client.accountantId, type, itemId, token);
            if (response.ok) {
                await fetchDocumentsNotification(client, token)
                toast.success(t('DocumentProcessed'), {
                    position: direction === 'rtl' ? 'top-left' : 'top-right'
                });
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentNotProcessed', { errorText: error.message }));
        }
        setLoading(false);
    };



    const handleNotDoneClick = async (itemId) => {
        setLoading(true);
        try {
            const response = await ClientDocumentCountService.addDocumentByTypeAndId(client.caseId, client.accountantId, type, itemId, token)
            if (response.ok) {
                await fetchDocumentsNotification(client, token)
                toast.success(t('DocumentProcessed'), {
                    position: direction === 'rtl' ? 'top-left' : 'top-right'
                });
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentNotProcessed', { errorText: error.message }));
        }
        setLoading(false);
    };


    const hideStatusBadge = false;

    const handleUpdate = async (itemId) => {
        setLoading(true);
        const documentUrl = editedDocument.documentUrl;
        console.log(editedDocument);
        
        try {
            const forceProcessFlag = forceProcessForCurrentEdit || editedDocument.forceProcess;
            if (!hideStatusBadge && editedDocument.status === 'done') {
                const isValid = await validateDocumentBeforeProcessing(editedDocument, t, client, !!forceProcessFlag);
                if (!isValid) {
                    setLoading(false);
                    return false;
                }
            }
            delete editedDocument.documentUrl;

            const response = await DocumentService.UpdateDocument(editedDocument.documentType || editedDocument.docType, token, editedDocument);
            if (!hideStatusBadge) {
                if (editedDocument.status == 'done') {
                    await handleDoneClick(editedDocument.id);
                }
                else if (editedDocument.status == 'notDone') {
                    await handleNotDoneClick(editedDocument.id);
                }
            }

            if (editedAddAccountCard) {
                await handleAccountCardSave(editedDocument.accountCodeId, editedDocument.accountCodeName, editedDocument.accountCaseId);
                await fetchEnums(user, token, client);
            }

            if (response.ok) {
                setForceProcessForCurrentEdit(false);
                editedDocument.documentUrl = documentUrl;

                await fetchVatEquipmentTransactions(fetchByYear ? startDate : null);
                await fetchEnums(user, token, client);

                toast.success(t("documentUpdateSuccess"), {
                    position: direction === 'rtl' ? 'top-left' : 'top-right'
                });
                setEditedAddAccountCard(false);
                setLoading(false);
                return true;
            } else {
                editedDocument.documentUrl = documentUrl;
                const errorText = await response.text();
                toast.error(t("documentUpdateError"));
                setEditedAddAccountCard(false);
                setLoading(false);
                return false;
            }
        } catch (error) {
            setEditedDocument({});
            setEditedAddAccountCard(false);
            setLoading(false);
            toast.error(t("documentUpdateError"));
            return false;
        }
    };




    const handleConfirm = async () => {
        if (actionType === 'delete') {
            await handleConfirmDelete();
        }
    };

    const getConfirmMessage = () => {
        switch (actionType) {
            case 'closeMonth':
                return t('AreYouSureCloseMonth');
            case 'openMonth':
                return t('AreYouSureOpenMonth');
            default:
                return t('confirmDeleteMessage');

        }
    };


    const getTitleMessage = () => {
        switch (actionType) {

            case 'closeMonth':
                return t('ConfirmCloseMonth');
            case 'openMonth':
                return t('ConfirmOpenMonth');
            default:
                return t('confirmDeleteTitle');
        }
    };

    const handleEditAddAccountChange = (selectedOption, field) => {
        if (field === 'AccountCodeId') {
            type === 'Incomes' ? setEditedDocument({ ...editedDocument, accountCodeId: selectedOption, debitAccount: selectedOption }) : setEditedDocument({ ...editedDocument, accountCodeId: selectedOption, creditAccount: selectedOption });
        }
        else if (field === 'accountCodeName') {

            setEditedDocument({ ...editedDocument, accountCodeName: selectedOption })
        }
        else {
            setEditedDocument({ ...editedDocument, accountCaseId: selectedOption })

        }
    };
    const handleCloseEditAddNewAccountCardDocument = () => {
        setEditedDocument({ ...editedDocument, accountCodeName: oldAccountName, accountCodeId: oldAccountCardId, accountCaseId: oldAccountCaseId });
        setEditedAddAccountCard(false);
    };

    const [reportingMonthDateCreate, setReportingMonthDateCreate] = useState(new Date());


    const handleRadioChange = async (e, options = {}) => {
        if (e.target.value?.toString() === 'done') {
            if (!options?.validationAlreadyDone) {
                const isValid = await validateDocumentBeforeProcessing(editedDocument, t, client, options?.forceProcess === true);
                if (!isValid) return;
            }
            if (options?.forceProcess) {
                setForceProcessForCurrentEdit(true);
            }
            setStatusCheck(true);
        }
        else if (e.target.value?.toString() === 'notDone') {
            setForceProcessForCurrentEdit(false);
            setStatusCheck(false);
        }
        setEditedDocument({ ...editedDocument, ["status"]: e.target.value });
    };

    const handleVatRadioChange = (e) => {
        setEditedDocument({ ...editedDocument, ["vat"]: parseFloat(e.target.value) });
    };

    const setReportingMonthDate = async (selectedDate, field) => {
        if (!selectedDate) {
            return;
        }
        const newDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), 10));
        const response1 = await ClientService.CheckIfMonthClosed(client.caseId, newDate, token);
        if (response1.ok) {
            const isClosedReportingMonth = await response1.json();
            if (isClosedReportingMonth) {
                toast.info(t('MonthReportAlreadyClosedTryAgain'));
                return
            }
            else {


                setEditedDocument({ ...editedDocument, [field]: newDate });
            }
        }
    }

    const CustomInput2 = React.forwardRef(({ value, onClick }, ref) => (
        <button className="edit-custom-input" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));

    const handleDateChange = (e, field) => {
        setEditedDocument({ ...editedDocument, [field]: e });
    };

    const updateAccountFields = (newValue, accountType) => {


        const isIncomesDebit = editedDocument.docType === 'Incomes' && accountType === 'debitAccount';
        const isExpensesCredit = editedDocument.docType === 'Expenses' && accountType === 'creditAccount';

        const updatedFields = {
            accountCodeId: isIncomesDebit || isExpensesCredit ? (newValue ? newValue.cardId : '') : '',
            accountCodeName: isIncomesDebit || isExpensesCredit ? (newValue ? newValue.name : '') : '',
            accountCaseId: isIncomesDebit || isExpensesCredit ? (newValue ? newValue.accountCaseId : '') : '',
        };

        // Update the edited item with the new fields
        setEditedDocument((prev) => ({
            ...prev,
            [accountType]: newValue ? newValue.cardId : '',
            ...(isIncomesDebit || isExpensesCredit ? updatedFields : {}),
        }));
    };

    const handleChange = (field, value) => {
        const updatedValue = value;

        if (field === 'sortCodeId') {

            if (!value || !sortCodeIdOptions.some((option) => option.sortCodeId === value)) {
                // Set default values for the empty state
                setEditedDocument({
                    ...editedDocument,
                    vat: 100, // Default VAT
                    [field]: '',
                });
                return; // Exit early since there's no valid sortCodeId
            }

            const name = sortCodeIdOptions.find(
                (option) => option.sortCodeId === value
            )?.sortCodeName || ''

            // Extract the name without the parentheses
            const nameWithoutParentheses = name.replace(/\s*\(.*?\)\s*/, '').trim();

            // Check for a number within parentheses
            const match = name.match(/\((\d+)%?/);
            let customVat = match ? parseInt(match[1], 10) : null;


            const sortCode = sortCodeIdOptions.filter(sc => sc.sortCodeId === updatedValue)[0];

            // Determine the VAT based on the name without parentheses
            const newVat = sortCode?.vat ?? 100;


            const accountCard = accountCardOptions.find(
                (item) => item.cardId === (type === 'Incomes' ? sortCode.debitAccount : sortCode.creditAccount)
            );

            const debit = accountCardOptions.find(
                (item) => item.cardId === sortCode.debitAccount
            );

            const credit = accountCardOptions.find(
                (item) => item.cardId === sortCode.creditAccount
            );



            if (value === '1') { //hova
                setEditedDocument({
                    ...editedDocument,
                    vat: newVat,
                    [field]: updatedValue,
                    creditAccount: null,
                    debitAccount: debit ? debit.cardId : editedDocument?.debitAccount,
                    accountCodeName: accountCard ? accountCard.name : editedDocument.accountCodeName,
                    accountCodeId: accountCard ? accountCard.cardId : editedDocument.accountCodeId,
                    accountCaseId: accountCard ? accountCard.accountCaseId : editedDocument.accountCaseId,
                });
                return;
            }
            if (value === '2') { //z5ot
                setEditedDocument({
                    ...editedDocument,
                    vat: newVat,
                    [field]: updatedValue,
                    creditAccount: credit ? credit.cardId : editedDocument?.creditAccount,
                    debitAccount: null,
                    accountCodeName: accountCard ? accountCard.name : editedDocument.accountCodeName,
                    accountCodeId: accountCard ? accountCard.cardId : editedDocument.accountCodeId,
                    accountCaseId: accountCard ? accountCard.accountCaseId : editedDocument.accountCaseId,
                });
                return;
            }


            setEditedDocument({
                ...editedDocument,
                vat: newVat,
                [field]: updatedValue,
                creditAccount: credit ? credit.cardId : editedDocument?.creditAccount,
                debitAccount: debit ? debit.cardId : editedDocument?.debitAccount,
                accountCodeName: accountCard ? accountCard.name : editedDocument.accountCodeName,
                accountCodeId: accountCard ? accountCard.cardId : editedDocument.accountCodeId,
                accountCaseId: accountCard ? accountCard.accountCaseId : editedDocument.accountCaseId,
            });

        }
        else if (field === 'creditAccount' || field === 'debitAccount') {

            // Use the helper function to update account fields for credit or debit account
            const newValue = accountCardOptions.find(option => option.cardId === updatedValue) || null;
            updateAccountFields(newValue, field);
        }
        else {
            // For fields other than sortCodeId, just update the edited item
            setEditedDocument({
                ...editedDocument,
                [field]: updatedValue,
            });
        }
    };


    const [isRange, setIsRange] = useState(() => {
        const storedIsRange = localStorage.getItem('IsRange');
        return storedIsRange === "true";
    });;

    const [originalAccountCardId, setOriginalAccountCardId] = useState('');


    const handleAccountChange = (selectedOption, field, CustomDropdownFlag = false) => {
        if (field === 'debitAccount' || field === 'creditAccount') {
            const accountCardEditDownload = accountCardEditDownloadOptions.find(option => option.cardId === selectedOption.value);
            const name = accountCardEditDownload?.name;
            const accountCaseId = accountCardEditDownload?.accountCaseId;
            if (selectedOption.value < 0) {

                setOriginalAccountCardId(editedDocument.cardId)
            }
            type === 'Incomes' ? setEditedDocument({ ...editedDocument, accountCodeName: name, accountCodeId: selectedOption.value, debitAccount: selectedOption.value, accountCaseId: accountCaseId }) : setEditedDocument({ ...editedDocument, accountCodeName: name, accountCodeId: selectedOption.value, creditAccount: selectedOption.value, accountCaseId: accountCaseId });
        } else if (field === 'accountCodeId') {
            if (selectedOption.value1 === 'AddItem') {
                setEditedAddAccountCard(true);
                setOldAccountName(editedDocument.accountCodeName);
                setOldAccountCaseId(editedDocument.accountCaseId);
                setOldAccountCardId(editedDocument.accountCodeId);
                setEditedDocument({ ...editedDocument, accountCodeName: '', accountCodeId: '', accountCaseId: '' });
            }
            else {
                const accountCardEdit = accountCardEditDownloadOptions.find(option =>
                    option.cardId === (CustomDropdownFlag ? selectedOption.cardId : selectedOption.value)
                );
                const name = accountCardEdit?.name;
                const accountCaseId = accountCardEdit?.accountCaseId;
                const cardId = CustomDropdownFlag ? selectedOption.cardId : selectedOption.value;
                setEditedDocument({ ...editedDocument, accountCodeName: name, accountCodeId: cardId, debitAccount: cardId, accountCaseId: accountCaseId })
            }
        }
    };

    const handleOpenEditSingleEntry = (item) => {
        setEditedDocument(item);
        console.log(item);
        setIsEditSingleEntryOpen(true);
        const idx = vatEquipmentTransactions.findIndex(
            (tx) =>
                tx.id === item.id &&
                ((tx.type === Constants.EntryType.Expense && (item.documentType === 'Expenses' || item.docType === 'Expenses')) ||
                    (tx.type === Constants.EntryType.JournalEntry && (item.documentType === 'JournalEntries' || item.docType === 'JournalEntries')))
        );
        setEditModalCurrentIndex(idx >= 0 ? idx : -1);
    };

    //----------------------------END EDIT MODAL SECTION-----------------------------------

    const handleAssignDocument = (row) => {


        // if (addGroupModalOpen || addModalOpen) {
        //     setAssignedDocument(row);
        //     setIsTransactionViewerOpen(false);
        // }
        if (row.participatingInDepreciation === 'No') {
            setAssignedDocument(row);
            setIsTransactionViewerOpen(false);
            setAddModalOpen(true);
        }

    }

    const handleCloseSave = async (row) => {
        await fetchEnums(user, token, client);
        if (isReportModalOpen) {
            await handleViewReport(reportDate);
        }
    }
    const fileInputRef = useRef();
    const buttonData = [
        {
            label: 'AddAsset',
            onClick: () => handleAddClick(true),
            icon: () => <AddCircleIcon fontSize="small" />
        },
        {
            label: 'AddAssetGroup',
            onClick: handleAddGroupClick,
            icon: () => <AddCircleIcon fontSize="small" />,
            style: {maxWidth: '200px'},
        },
        {
            label: 'DepreciationFormYA',
            onClick: handleViewReport
        },
        {
            label: 'ViewEquipmentTransactions',
            onClick: () => setIsTransactionViewerOpen(true)
        },
        {
            label: 'UpdateDepreciationJournalEntries',
            onClick: () => setIsJournalEntrySelectionModalOpen(true)
        },
        {
            label: 'ImportAssets',
            onClick: () => setShowAssetImportModal(true),
            icon: () => <DriveFolderUploadIcon fontSize="small" />
        },
        {
            label: 'ViewSoldAssets',
            onClick: () => setShowSoldAssetsViewer(true)
        },
        {
            label: 'CapitalGainFormGeneration',
            onClick: () => {
                setSelectedCapitalGainAsset(null);
                setShowCapitalGainSoldModal(true);
            },
        },
        {
            label: 'DepreciationSnapshots',
            onClick: () => setShowSnapshotViewer(true)
        }
    ];

    return (
        <>

            <SmallTransactionViewer
                transactions={vatEquipmentTransactions}
                open={isTransactionViewerOpen}
                onClose={() => setIsTransactionViewerOpen(false)}
                viewDocument={viewDocument}
                handleAssignDocument={handleAssignDocument}
                assets={assets}
                startDate={startDate}
                endDate={endDate}
                setStartDate={handleStartDateChange}
                setEndDate={handleEndDateChangeNew}
            />


            <EditAsset
                caseId={client?.caseId}
                open={editModalOpen}
                onClose={closeEditModal}
                asset={selectedAsset}
                assetGroups={assetGroups}
                assets={assets}
                assetRelations={assetRelations}
                refreshAssets={() => fetchEnums(user, token, client)}
                refreshRelations={async () => {
                    try {
                        const relationsResponse = await AssetService.GetAssetRelationsByCaseId(client?.caseId, token);
                        if (relationsResponse?.success) {
                            setAssetRelations(relationsResponse.data || []);
                        }
                    } catch (err) {
                        console.error('Error refreshing asset relations:', err);
                    }
                }}
                onDelete={handleDelete}
                onSave={handleCloseSave}
                viewDocument={viewAssetDocument}
                token={token}
                accountantId={client?.accountantId}
                sortCodeIdOptions={sortCodeIdOptions}
            />
            <AddAsset
                open={addModalOpen}
                onClose={closeAddModal}
                refreshAssets={() => fetchEnums(user, token, client)}
                handleSave={handleAddAsset}
                viewAttachDocument={viewAttachDocument}
                assets={assets}
                assignedDocument={assignedDocument}
                assetGroups={assetGroups}
                assetRelations={assetRelations}
                caseId={client?.caseId}
                token={token}
                client={client}
                user={user}
                fetchEnums={fetchEnums}
                onOpenAddGroupModal={() => setAddGroupModalOpen(true)}
            />

            <AddAssetGroup
                open={addGroupModalOpen}
                onClose={closeAddGroupModal}
                caseId={client?.caseId}
                refreshAssetGroups={() => fetchEnums(user, token, client)}
                assetGroups={assetGroups}
                token={token}
            />

            <EditAssetGroup
                open={editGroupModalOpen}
                onClose={closeEditGroupModal}
                caseId={client?.caseId}
                assetGroup={selectedAssetGroup}
                refreshAssetGroups={() => fetchEnums(user, token, client)}
                onDelete={() => fetchEnums(user, token, client)}
                token={token}

            />


            {/* Depreciation Report Dialog */}
            <AssetDepreciationReportHTML
                open={isReportModalOpen}
                depreciationContent={depreciationData}
                assetRelations={assetRelations}
                client={client}
                date={reportDate}
                token={token}
                onRowClick={handleRowClick}
                onClose={handleCloseReport}
                reportDate={reportDate}
                handleEndDateChangeNew={handleEndDateChangeNew}
                setReportDate={setReportDate}
                onRefreshWithRange={async (endMonth) => {
                    await handleViewReport(endMonth, endMonth);
                }}
            />

            {/* Journal Entry Selection Modal */}
            <DepreciationJournalEntriesModal
                open={isJournalEntrySelectionModalOpen}
                onClose={() => setIsJournalEntrySelectionModalOpen(false)}
                onConfirm={() => setIsJournalEntrySelectionModalOpen(false)}
                client={client}
                token={token}
                selectedEntries={[]}
                title="UpdateDepreciationJournalEntries"
                direction={direction}
                debitAccountOptions={debitAccountOptions}
                sortCodeIdOptions={sortCodeIdOptions}
                onJournalEntryCreated={async () => {
                    // Refresh enums in HamburgerMenu to update TransactionSearchResultModal
                    if (refreshEnumsCallback) {
                        refreshEnumsCallback();
                    }
                    // Refresh depreciation data if report modal is open
                    // if (isReportModalOpen) {
                    //     await handleViewReport(reportDate);
                    // }
                }}
            />

            <AssetImportModal
                open={showAssetImportModal}
                onClose={() => setShowAssetImportModal(false)}
                caseId={client?.caseId}
                token={token}
                refreshAssets={() => fetchEnums(user, token, client)}
            />

            <SoldAssetsViewer
                open={showSoldAssetsViewer}
                onClose={() => setShowSoldAssetsViewer(false)}
                assets={assets}
                assetGroups={assetGroups}
                assetRelations={assetRelations}
                onRowClick={handleRowClick}
            />

            <CapitalGainSoldAssetsModal
                open={showCapitalGainSoldModal}
                onClose={() => setShowCapitalGainSoldModal(false)}
                assets={assets}
                assetGroups={assetGroups}
                assetRelations={assetRelations}
                onSelectAsset={(asset) => {
                    setSelectedCapitalGainAsset(asset);
                    setShowCapitalGainSoldModal(false);
                }}
            />

            <CapitalGainCalculationModal
                open={Boolean(selectedCapitalGainAsset)}
                onClose={() => setSelectedCapitalGainAsset(null)}
                asset={selectedCapitalGainAsset}
                caseId={client?.caseId}
                clientName={client?.name}
                caseType={client?.caseType}
                direction={direction}
                token={token}
            />

            <SnapshotViewer
                open={showSnapshotViewer}
                onClose={() => setShowSnapshotViewer(false)}
                caseId={client?.caseId}
                token={token}
            />

            {editedDocument && editedPopupItem && Object.keys(editedDocument).length > 0 && (
                <EditModal
                    editedItem={editedDocument}
                    fade={fade}
                    subAccountantOptions={subAccountantOptions}
                    handlePrevious={handleEditModalPrevious}
                    handleNext={handleEditModalNext}
                    currentIndex={editModalCurrentIndex}
                    filteredAndSortedData={filteredAndSortedDataForEditModal}
                    NoDocumentsPdf={NoDocumentsPdf}
                    t={t}
                    handleAccountChange={handleAccountChange}
                    isRange={isRange}
                    isClosedReportingMonth={isClosedReportingMonth}
                    accountCardOptions={accountCardOptions}
                    handleChange={handleChange}
                    handleDateChange={handleDateChange}
                    CustomInput2={CustomInput2}
                    setReportingMonthDate={setReportingMonthDate}
                    handleVatRadioChange={handleVatRadioChange}
                    statusCheck={statusCheck}
                    handleRadioChange={handleRadioChange}
                    type={editedDocument.docType || editedDocument.documentType || type}
                    editedAddAccountCard={editedAddAccountCard}
                    handleCloseEditAddNewAccountCardDocument={handleCloseEditAddNewAccountCardDocument}
                    handleEditAddAccountChange={handleEditAddAccountChange}
                    sortCodeIdOptions={sortCodeIdOptions}
                    debitAccountOptions={debitAccountOptions}
                    creditAccountOptions={creditAccountOptions}
                    handleUpdate={handleUpdate}
                    handleCancel={handleCancel}
                    handleDeleteClick={handleEditDeleteClick}
                    client={client}
                    token={token}
                    setAccountCardOptions={setAccountCardOptions}
                    setLoading={setLoading}
                    setEditedAddAccountCard={setEditedAddAccountCard}
                    setEditedItem={setEditedDocument}
                    handleReopenEdit={handleReopenEdit}
                    palCodes={formattedPalCodeOptions}
                    RefreshPage={RefreshPage}
                    handleAccountCardSave={handleAccountCardSave}
                    fetchEnums={fetchEnums}
                    assets={assets}
                    assetClicked={() => { }}
                    accountCards={[]}
                    hideStatus={false}
                    showForceProcess={false}
                />
            )}



            <CustomDeleteConfirmationModal
                isVisible={deleteModalVisable}
                onClose={() => setDeleteModalVisable(false)}
                onDelete={handleConfirm}
                confirmMessage={getConfirmMessage()}
                titleMessage={getTitleMessage()}
                type={actionType}
            />

            <>
                <>
                    <NavigationButton
                        t={t}
                        direction={direction}
                        data={buttonData}
                    />

                    <div
                        className={`searchFilter-bar__container document-toolbar-row ${direction}`}
                        style={{ alignItems: 'flex-start' }}
                    >
                        <Box className="document-filter-row" dir={direction}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1, flexWrap: 'nowrap', flexShrink: 0 }}>
                                {fetchByYear ? (
                                    <CustomYearDatePicker
                                        date={startDate}
                                        label={t('Year')}
                                        onDateChange={handleYearChangeForDataFetch}
                                        height="var(--xtram-control-height, 40px)"
                                        width="120px"
                                    />
                                ) : (
                                    <CustomMonthDatePicker
                                        date={endDate}
                                        label={t('UpToMonth') || 'עד חודש'}
                                        onDateChange={handleEndMonthChange}
                                        height="var(--xtram-control-height, 40px)"
                                        width="150px"
                                    />
                                )}

                                <TextField
                                    size="small"
                                    dir={direction}
                                    placeholder={t('Search')}
                                    value={searchQuery || ''}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className="document-search-bar"
                                    variant="standard"
                                    InputProps={{
                                        disableUnderline: true,
                                        className: `custom-input-box-sizing ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon className="document-search-icon" />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Box>
                        </Box>

                        <Box
                            dir={direction}
                            sx={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: 1,
                                flexWrap: 'nowrap',
                                flexShrink: 0,
                            }}
                        >

                            <Box className="document-mode-toggles document-mode-toggles--match-search">
                            <Box className={`document-mode-toggle${fetchByYear ? ' is-checked' : ''}`}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={fetchByYear}
                                            onChange={async (e) => {
                                                const newVal = e.target.checked;
                                                setFetchByYear(newVal);
                                                if (client && token && user) {
                                                    setLoading(true);
                                                    await fetchEnums(user, token, client, null, newVal);
                                                }
                                            }}
                                            size="small"
                                            inputProps={{ 'aria-label': t('FetchByYear') }}
                                        />
                                    }
                                    label={t('FetchByYear')}
                                />
                            </Box>
                            <Box className={`document-mode-toggle${showEmptyGroups ? ' is-checked' : ''}`}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={showEmptyGroups}
                                            onChange={(e) => setShowEmptyGroups(e.target.checked)}
                                            size="small"
                                            inputProps={{ 'aria-label': t('ShowEmptyGroups') }}
                                        />
                                    }
                                    label={t('ShowEmptyGroups')}
                                />
                            </Box>
                            </Box>
                            <DenseTable
                                headers={equipmentAssetSummaryHeader}
                                rows={equipmentAssetSummaryRows}
                                reverse={true}
                                width="500px"
                                styleFlag
                                headerStyle={{
                                    opacity: 0.6,
                                    background: 'var(--orange, #F9AA2A)',
                                    textAlign: 'center',
                                    minHeight: '50px'
                                }}
                                rowStyle={{
                                    borderTop: '1px solid rgba(191, 191, 193, 0.56)',
                                    background: 'var(--secondary-12, rgba(254, 247, 234, 0.12))',
                                    minHeight: '50px'
                                }}
                            />
                        </Box>
                    </div>

                    {/* current table */}
                    <div className='table-container' style={{ overflowX: 'hidden', display: "flex", flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: '16px' }} >

                        <AssetTable
                            assets={assets}
                            assetGroups={assetGroups}
                            assetRelations={assetRelations}
                            expandedRows={expandedRows}
                            handleExpandClick={handleExpandClick}
                            onRowClick={handleRowClick}
                            searchQuery={searchQuery}
                            showEmptyGroups={showEmptyGroups}
                            t={t}
                        />

                    </div>
                </>

                {/* <HamburgerMenu client={client} /> */}

                <ToastContainer position={direction === 'rtl' ? 'top-left' : 'top-right'} rtl={direction === 'rtl'} />
                {loading && (
                    <div className="loader-container">
                        <PuffLoader
                            size={100}        // Larger size for better visibility
                            loading={loading}
                        />
                    </div>
                )}
            </>

        </>
    );
}


export default Assets;
